const az = {
  translation: {
    externalCode: "Kod",
    erpCode: "ERP kodu",
    barcode: "Barkod",
    aynaCode: "AYNA Kod",
    swal: {
      confirmPasswordTitle: "Əməliyyatı təsdiqləmək üçün şifrənizi daxil edin",
      deleteReason: "Silinmə səbəbi",
      success: "Əməliyyat uğurla bitdi",
      error: "Xəta baş verdi",
      edit: "Dəyişikliklər olundu",
      receipt: "Qaimə nömrəsini daxil edərək davam edin",
      cancelReason: "İmtina səbəbi",
      reason: "Səbəb",
      lossPercentage: "İtki faizini daxil edin",
    },
    aiAnalyze: {
      color: 'Rəng',
      make: 'Marka',
      model: 'Model',
      plateNumber: 'Nömrə',
      image: 'Şəkil',
      apply: 'Tətbiq et'
    },
    login: {
      email: "E-poçt ünvanı",
      password: "Şifrə",
      confirmPassword: "Təkrar şifrə",
      submit: "Giriş",
      chooseScale: "Tərəzini seçin",
    },
    register: {
      default: "Qeydiyyat",
      authorizedPersonFirstName: "Səlahiyyətli şəxsin adı",
      authorizedPersonLastName: "Səlahiyyətli şəxsin soyadı",
      addCompanySuccess:
        "Qeydiyyatdan uğurla keçdiniz. Zəhmət olmasa, email ünvanınıza göndərilmiş linkə daxil olaraq qeydiyyatı tamamlayın.",
      emailValidateSuccess: "Qeydiyyatınız uğurla tamamlandı.",
      companyRegistration: "Şirkət qeydiyyatı",
      operatorCompanyRegistration: "Operator şirkətin qeydiyyatı",
      userRegistration: "İstifadəçinin qeydiyyatı",
      asterisk: "olan xanaları doldurmaq məcburidir.",
      registerSuccess: "Qeydiyyat uğurla tamamlandı.",
    },
    header: {
      profile: "Profil",
      changePassword: "Şifrəni yenilə",
      logout: "Çıxış",
    },
    dashboard: {
      income: "Mədaxil",
      expense: "Məxaric",
      automaticScale: "Avtomatik çəkim",
      numberOfTrucks: "Avtomobil sayı",
    },
    operation: {
      default: "Əməliyyat",
      plural: "Əməliyyatlar",
      type: "Əməliyyat növü",
      completed: "Tamamlanmış əməliyyat",
      net: "Net əməliyyat",
      date: "Əməliyyat tarixi",
      weight1: "Çəki 1",
      weight2: "Çəki 2",
      weight1Date: "Çəki 1 Tarixi",
      weight2Date: "Çəki 2 Tarixi",
      receipt1: "Qəbz",
      receipt2: "Qaimə",
      aks: "AKS",
      aksList: "AKS siyahısı",
      aksPreview: "AKS görüntü",
      aksType: "AKS tipi",
      username: "İstifadəçi",
      createDate: "Yaradılma tarixi",
      preview: "Önizləmə",
      image: "Şəkil {{number}}", 
      removeAksTitle: "AKS silinsin?",
      removeAksText: "AKS sıra nömrəsi {{number}} silinəcək.",
      waitingIncomes: "Gözlənilən mədaxillər",
      waitingExpenses: "Gözlənilən məxariclər",
      lossPercentage: "İtki faizi",
      lossPercentageEdit: "İtki faizin dəyiş",
      lossPercentageDate: "İtki faizi tarixi",
      lossPercentageAmount: "İtki miqdarı",
      warehouse: "Anbar",
      trailers: "Qoşqular",
      completeWithTechPass: "Texpassport dəyəri ilə təsdiqlə",
      divideCustomer: "Müştəri bölüşdür",
      divideSender: "Göndərən bölüşdür",
      dividedSum: "Bölüşdürülən çəki",
      remainingSum: "Qalan çəki",
      isDividedCustomer: "Bu əməliyyatda müştəri bölüşdürülmüşdür",
      isDividedSender: "Bu əməliyyatda göndərən bölüşdürülmüşdür",
      aynaStatus: "AYNA status",
      downloadingAynaDocument: "Yüklənir...",
      resendToAyna: "Yenidən göndər",
      sendToAyna: "Göndər",
      sendingToAyna: "Göndərilir...",
      downloadAynaDocument: "Yüklə",
      aynaWaybill: "ƏMTƏƏ-NƏQLİYYAT QAİMƏSİ",
      aynaRoutebill: "YOL VƏRƏQƏSİ",
      aynaWaybillNumber: "ƏMTƏƏ-NƏQLİYYAT QAİMƏSİ nömrəsi",
      aynaRoutebillNumber: "YOL VƏRƏQƏSİ nömrəsi",
      aynaNotSent: "Göndərilməyib",
      aynaDownloadPending: "Yükləmə API-si hələ hazır deyil",
      aynaHistory: "Tarixçə",
      aynaNumber: "AYNA nömrə",
    },
    report: {
      default: "Hesabat",
      rowsPerPage: "Sətir/səhifə",
      noChange: "Dəyişiklik haqqında məlumat yoxdur",
      all: "Bütün hesabatlar",
      detailed: "Ətraflı hesabat",
      sum: "Cəmi",
      weightNetWithoutLossPercentage: "Xalis çəki",
      CompletedWithoutWeight2Tara: "Yalnız Tara əməliyyatları",
      notApproveOperation: "Şübhəli əməliyyat",
      suspiciousEmpty: "Şübhəli boş",
      suspiciousFull: "Şübhəli dolu",
    },
    trailer: {
      default: "Qoşqu",
      plural: "Qoşqular",
      numberPlate: "Qoşqu nömrəsi",
      supplier: "Qoşqu təchizatçısı",
      brand: "Qoşqu markası",
      model: "Qoşqu modeli",
      add: "YENİ QOŞQU ƏLAVƏ ET",
      create: "Qoşqunun yaradılması",
      edit: "Qoşqunun dəyişdirilməsi",
      addToast: "Qoşqu əlavə olundu",
      details: "Qoşqu detalları",
    },
    truck: {
      default: "Avtomobil",
      numberPlate: "Avtomobil nömrəsi",
      owner: "Sürücü",
      brand: "Avtomobil markası",
      model: "Avtomobil modeli",
      emptyWeight: "Boş çəki",
      emptyWeightHistory: "Boş çəki tarixçəsi",
      clearEmptyWeight: "Boş çəkinin sıfırlanması",
      confirmClearEmptyWeight: "Boş çəkini sıfırlanmaq istədiyinizə əminsinizmi?",
      emptyWeightDate: "Boş çəki tarixi",
      supplier: "Avtomobil təchizatçısı",
      add: "YENİ AVTOMOBİL ƏLAVƏ ET",
      create: "Avtomobilin yaradılması",
      edit: "Avtomobilin dəyişdirilməsi",
      addToast: "Avtomobil əlavə olundu",
      details: "Avtomobil detalları",
      type: "Avtomobilin tipi",
      technicalPassportNumber: "Tex pasport nömrəsi",
      technicalPassportWeight: "Tex pasport ağırlığı",
      maxAllowedWeight: "Maksimum çəki",
      licenceNumber: "Lisenziya nömrəsi",
      licenceExpireDate: "Lisenziyanın son istifadə tarixi",
      licenceTypeName: "Lisenziya növü",
      axleCount: "Ox sayı",
      EmptyWeight1: 'Əvvəlki boş çəki',
      EmptyWeight2: 'Yeni boş çəki',
    },
    truckOwner: {
      default: "Sürücü",
      name: "Sürücü adı",
      surname: "Sürücü soyadı",
      fin: "FİN",
      supplier: "Sürücü təchizatçısı",
      driverLicenseNumber: "Sürücülük vəsiqəsi nömrəsi",
      driverLicenseExpiryDate: "Sürücülük vəsiqəsinin son istifadə tarixi",
      add: "YENİ SÜRÜCÜ ƏLAVƏ ET",
      create: "Sürücünün yaradılması",
      edit: "Sürücünün dəyişdirilməsi",
      addToast: "Sürücü əlavə olundu",
      details: "Sürücü detalları",
    },
    cargo: {
      default: "Yük",
      name: "Yük adı",
      type: "Yük növü",
      note: "Yük qeydi",
      unitOfMeasure: "Ölçü vahidi",
      price: "Qiymət",
      contractNumber: "Müqavilə sıra nömrəsi",
      numMeasurementUnit: "Say ölçü vahidi",
      massMeasurementUnit: "Kütlə ölçü vahidi",
      add: "YENİ YÜK ƏLAVƏ ET",
      create: "Yükün yaradılması",
      edit: "Yükün dəyişdirilməsi",
      addToast: "Yük əlavə olundu",
      details: "Yük detalları",
    },
    cargoType: {
      default: "Yük tipi",
      add: "YENİ YÜK TİPİ ƏLAVƏ ET",
      create: "Yük tipinin yaradılması",
      edit: "Yük tipinin dəyişdirilməsi",
      addToast: "Yük tipi əlavə olundu",
    },
    deliveryType: {
      default: "Çatdırılma növü",
      add: "YENİ ÇATDIRILMA NÖVÜ ƏLAVƏ ET",
      create: "Çatdırılma növünün yaradılması",
      edit: "Çatdırılma növünün dəyişdirilməsi",
      addToast: "Çatdırılma növü əlavə olundu",
    },
    orderPartStep: {
      label: "Step status",
    },
    orderPartStepCompany: {
      label: "Step status",
      qr: "QR-kod data",
    },
    subCargo: {
      default: "Alt yük",
      name: "Alt yük adı",
      type: "Alt yük növü",
      note: "Alt yük qeydi",
      add: "YENİ ALT YÜK ƏLAVƏ ET",
      create: "Alt yükün yaradılması",
      edit: "Alt yükün dəyişdirilməsi",
      addToast: "Alt yük əlavə olundu",
      details: "Alt yük detalları",
    },
    company: {
      default: "Şirkət",
      type: "Şirkət tipi",
      operatorCompany: "Operator şirkət",
      name: "Şirkət adı",
      usageEnvironment: "İstifadə mühiti",
      licenseStartDate: "Lisenziya başlama tarixi",
      licenseEndDate: "Lisenziya bitmə tarixi",
      calibrationStartDate: "Kalibrasiya başlama tarixi",
      nextCalibrationDate: "Növbəti kalibrasiya tarixi",
      voen: "VÖEN",
      camera: "Kamera",
      qrCode: "QR kod",
      printForm: "Çap forması",
      founderTelegramNumber: "Təsisçi telegram nömrəsi",
      add: "YENİ ŞİRKƏT ƏLAVƏ ET",
      create: "Şirkətin yaradılması",
      edit: "Şirkətin dəyişdirilməsi",
      addToast: "Şirkət əlavə olundu",
      approveOperatorCompany:
        "Operator şirkəti təsdiqləmək istədiyinizdən əminsinizmi?",
      rejectOperatorCompany: "Operator şirkətdən imtina?",
      createTelegramChannel: "Telegram kanalı yarat",
      deleteMessage:
        "Bu şirkətə bağlı olan bütün istifadəçilər silinəcək. Əminsiniz?",
      details: "Şirkət detalları",
      ip: "IP adresi",
      operationDivideAvailable: "Çoxlu müştəri/göndərən",
      netPoolAvailable: "Net Hovuzu",
      aynaSyncAvailable: "AYNA İnteqrasiya",
      notApproveOperationCheckHour: "Şübhəli əməliyyat saatı",
      aiExist: "AI mövcuddur",
      aiType: "AI növü",
      aiToken: "AI Token",
      aiSettings: "AI parametrləri",
    },
    companyAllowedIpAddress: {
      addToast: "IP adres əlavə olundu",
      add: "YENİ IP ADRES ƏLAVƏ ET",
      create: "IP adresin əlavə edilməsi",
      edit: "IP adresin dəyişdirilməsi",
    },
    scaleCamera: {
      addToast: "Kamera əlavə olundu",
      add: "YENİ KAMERA ƏLAVƏ ET",
      create: "Kameranın əlavə edilməsi",
      edit: "Kameranın dəyişdirilməsi",
      name: "Kamera adı",
      url: "Kamera URL",
      aiExist: "AI mövcuddur",
      cameraType: "Kamera növü",
    },
    senderWarehouseConfig: {
      addToast: "Config əlavə olundu",
      add: "YENİ CONFİG ƏLAVƏ ET",
      create: "Configin əlavə edilməsi",
      edit: "Configin dəyişdirilməsi",
    },
    customer: {
      default: "Müştəri",
      name: "Müştəri adı",
      distance: "Məsafə",
      voen: "VÖEN",
      add: "YENİ MÜŞTƏRİ ƏLAVƏ ET",
      create: "Müştərinin yaradılması",
      edit: "Müştərinin dəyişdirilməsi",
      addToast: "Müştəri əlavə olundu",
      details: "Müştəri detalları",
      zipCode: "Zip kod",
    },
    customerBranch: {
      default: "Müştəri filialı",
      name: "Müştəri filialı adı",
      plural: "Müştəri və ya təchizatçı filialları",
      add: "YENİ MÜŞTƏRİ FİLİALI ƏLAVƏ ET",
      create: "Müştəri filialının yaradılması",
      edit: "Müştəri filialının dəyişdirilməsi",
      addToast: "Müştəri filialı əlavə olundu",
      details: "Müştəri filialı detalları",
      back: "Müştəri filiallarına bax",
    },
    customerWarehouse: {
      default: "Müştəri anbarı",
      name: "Müştəri anbarı adı",
      add: "YENİ MÜŞTƏRİ ANBARI ƏLAVƏ ET",
      create: "Müştəri anbarının yaradılması",
      edit: "Müştəri anbarının dəyişdirilməsi",
      addToast: "Müştəri anbarı əlavə olundu",
      details: "Müştəri anbarı detalları",
    },
    senderWarehouse: {
      default: "Göndərən anbarı",
      name: "Göndərən anbarı adı",
      add: "YENİ GÖNDƏRƏN ANBARI ƏLAVƏ ET",
      create: "Göndərən anbarının yaradılması",
      edit: "Göndərən anbarının dəyişdirilməsi",
      addToast: "Göndərən anbarı əlavə olundu",
      details: "Göndərən anbarı detalları",
    },
    supplier: {
      default: "Təchizatçı",
      name: "Təchizatçı adı",
      branch: "Təchizatçı filialı",
    },
    sender: {
      default: "Göndərən",
      name: "Göndərən adı",
      voen: "VÖEN",
      add: "YENİ GÖNDƏRƏN ƏLAVƏ ET",
      create: "Göndərənin yaradılması",
      edit: "Göndərənin dəyişdirilməsi",
      addToast: "Göndərən əlavə olundu",
      details: "Göndərən detalları",
    },
    senderBranch: {
      default: "Göndərən filialı",
      name: "Göndərən filialı adı",
      plural: "Göndərən filialları",
      add: "YENİ GÖNDƏRƏN FİLİALI ƏLAVƏ ET",
      create: "Göndərən filialının yaradılması",
      edit: "Göndərən filialının dəyişdirilməsi",
      addToast: "Göndərən filialı əlavə olundu",
      details: "Göndərən filialı detalları",
      back: "Göndərən filiallarına bax",
    },
    companyBranch: {
      default: "Şirkət filialı",
      name: "Şirkət filialı adı",
      plural: "Şirkət filialları",
      add: "YENİ ŞİRKƏT FİLİALI ƏLAVƏ ET",
      create: "Şirkət filialının yaradılması",
      edit: "Şirkət filialının dəyişdirilməsi",
      addToast: "Şirkət filialı əlavə olundu",
      details: "Şirkət filialı detalları",
      back: "Şirkət filiallarına bax",
    },
    scale: {
      default: "Tərəzi",
      name: "Tərəzi adı",
      add: "YENİ TƏRƏZİ ƏLAVƏ ET",
      create: "Tərəzinin yaradılması",
      edit: "Tərəzinin dəyişdirilməsi",
      addScaleCard: "Tərəzi kartı əlavə et",
      updateScaleCard: "Tərəzi kartı redaktə et",
      addToast: "Tərəzi əlavə olundu",
      expectedValue: "Çəki fərqi",
      details: "Tərəzi detalları",
      weight2CanChange: "Çəki 2 dəyişiklik",
      IsAks: "Aks rejimi",
      qrScale: "QR kod tartım",
      construction: 'Konsturksiya',
      kind: 'Növü',
      type: 'Tipi',
      brand: 'Tərəzinin Markası',
      model: 'Tərəzinin Modeli',
      bodyLength: 'Gövdənin uzunluğu',
      bodyWidth: 'Gövdənin eni',
      loadcellNumber: 'Loadcellərin sayı',
      loadcellBrand: 'Loadcellin Markası',
      loadcellModel: 'Loadcellin Modeli',
      loadCellCableType: 'Loadcell kabelinin növü',
      loadCellCableLength: 'Loadcell kabelinin uzunluğu',
      indicatorBrand: 'İndiqatorun Markası',
      indicatorModel: 'İndiqatorun Modeli',
      walkingStep: 'Yerimə addımı',
      junctionBoxBrand: 'Junction box Markası',
      junctionBoxModel: 'Junction box Modeli',
      maximumWeight: 'Maksimum ağırlıq',
      minimumWeight: 'Minimum ağırlıq',
      images: 'Tərəzinin şəkilləri',
      aiChecking: 'AI Yoxlama',
    },
    serviceCard: {
      add: 'Servis kartı əlavə et',
      update: 'Servis kartı redaktə et',
      kind: 'Servis Növü',
      part: 'Servis edilən hissə',
      customer: 'Servisi edən şirkət',
      person: 'Servisi edən şəxs',
      problem: 'Aşkar edilən problem',
      problemSolution: 'Problemin həlli',
      createdUser: 'Yaradan istifadəçi',
      code: 'Kod',
      files: 'Sənədlər',
      serviceDate: 'Servis Tarixi'
    },
    order: {
      default: "Sifariş",
      plural: "Sifarişlər",
      add: "YENİ SİFARİŞ YARAT",
      addToast: "Sifariş yaradıldı",
      hasOperation: "Əməliyyatda istifadə edilib",
      isCompleted: "Tamamlanıb",
      details: "Sifariş detalları",
      id: "Sifariş nömrəsi",
      creditType: "Kredit limiti",
      typeWeightLimit: "Limit",
    },
    orderPart: {
      default: "Sifariş bağlantısı",
      plural: "Sifariş bağlantıları",
      add: "YENİ SİFARİŞ BAĞLANTISI YARAT",
      create: "Sifariş bağlantısının yaradılması",
      edit: "Sifariş bağlantısının dəyişdirilməsi",
      addToast: "Sifariş bağlantısı yaradıldı",
      editStep: "Step statusu dəyişdirildi",
      details: "Sifariş bağlantısı detalları",
      log: "Sifariş bağlantısı tarixçəsi",
      logonOrderNo:"ERP inteqrasiya kodu"
    },
    logonRequest: {
      details: "Ətraflı",
    },
    subOrders: {
      default: "Alt Sifariş",
      plural: "Alt Sifarişlər",
      add: "YENİ ALT SİFARİŞ YARAT",
      edit: "Alt Sifariş dəyişdirilməsi",
      create: "Alt Sifariş  yaradılması",
      addToast: "Alt Sifariş yaradıldı",
      details: "Alt Sifariş detalları",
      ID: "Id",
      PreviousVolume: "Əvvəlki Həcm (kq)",
      RemainingVolume: "Qalan Həcm (kq)",
      IsCompleted: "Tamamlanıb?",
      SubOrderType: "Tip",
      CreateDate: "Yaranma Tarixi",
    },
    truckType: {
      default: "Avtomobil tipi",
      add: "YENİ AVTOMOBİL TİPİ ƏLAVƏ ET",
      create: "Avtomobil tipinin yaradılması",
      edit: "Avtomobil tipinin dəyişdirilməsi",
      addToast: "Avtomobil tipi yaradıldı",
    },
    carBrand: {
      default: "Avtomobil markası",
      name: "Avtomobil markasının adı",
      add: "YENİ AVTOMOBİL MARKASI ƏLAVƏ ET",
      create: "Avtomobil markasının yaradılması",
      edit: "Avtomobil markasının dəyişdirilməsi",
      addToast: "Avtomobil markası yaradıldı",
    },
    carModel: {
      default: "Avtomobil modeli",
      name: "Avtomobil modelinin adı",
      add: "YENİ AVTOMOBİL MODELİ ƏLAVƏ ET",
      create: "Avtomobil modelinin yaradılması",
      edit: "Avtomobil modelinin dəyişdirilməsi",
      addToast: "Avtomobil modeli yaradıldı",
    },
    camera: {
      default: "Kamera",
      url: "Kamera URL",
      ContinueCameraError: "Kamera xətası olsa da, çəkimə davam et",
      errors: "Kamera xətaları",
      errorType: "Xəta növü",
      weightError: "Çəki",
      SensorInputForOperation: "Əməliyyat üçün sensor girişi",
      Cargo2WeightOnNetWeight: "Alt yükün çəkisinin ümumi çəkidən çıxılması",
    },
    automaticScale: {
      default: "Avtomatik çəkim",
      startTime: "Başlama vaxtı",
      minWeight: "Minimum çəki",
    },
    status: {
      default: "Status",
    },
    date: {
      default: "Tarix",
      start: "Başlanğıc tarix",
      end: "Son tarix",
      createdAt: "Yaranma tarixi",
      installationDate: 'Quraşdırılma tarixi'
    },
    time: {
      default: "Saat",
      difference: "Saat fərqi",
      years: "il",
      months: "ay",
      days: "gün",
      hours: "saat",
      minutes: "dəqiqə",
      seconds: "saniyə",
      milliseconds: "millisaniyə",
    },
    actions: {
      default: "Əməliyyatlar",
      single: "Əməliyyat",
      taken: "İcraçı",
    },
    image: {
      default: "Şəkil",
    },
    buttons: {
      filter: "FİLTER",
      search: "Axtar",
      reset: "Yenilə",
      export: "Xaric et",
      print: "Çap et",
      columns: "Sütunlar",
      today: "Bugün",
      groups: "Qruplar",
      save: "Yadda saxla",
      confirm: "Təsdiqlə",
      cancel: "İmtina",
      delete: "Sil",
      decide: "Qərar qəbul et",
      back: "Geri",
      next: "İrəli",
      emptyWeight: 'Boş çəkini qeydə al'
    },
    inputs: {
      select: "Seçin",
    },
    checks: {
      printImages: "Şəkilləri çap et",
    },
    errors: {
      noData: "Məlumat tapılmadı",
      noOperationPermission: "Tartım etmək üçün icazəniz yoxdur",
      noChangeInfo: "Dəyişiklik haqqında məlumat yoxdur",
      noRfidCard: "Kartda məlumat yoxdur",
      noRfidCardOperation: "Kart bağlantısı yoxdur",
      noWeight: "Ağırlıq dəyəri təyin edilə bilmədi",
      minWeight: "Ağırlıq dəyəri icazə verilən minimal çəkidən azdır",
      noCustomer: "Bu VÖEN ilə müştəri əlavə edilməyib",
      customerNotFound: "Müştəri tapılmadı",
      truckNotFound: "Avtomobil tapılmadı",
      senderNotFound: "Göndərən tapılmadı",
      customerBranchNotFound: "Müştəri filialı tapılmadı",
      noSender: "Bu VÖEN ilə göndərən əlavə edilməyib",
      senderBranchNotFound: "Göndərən filialı tapılmadı",
      fillInGaps: "Xanaları doldurun",
      noCargo: "Bu adda yük əlavə edilməyib",
      cargoNotFound: "Yük tapılmadı",
      noWeight1: "Çəki 1 boş ola bilməz. Zəhmət olmasa, səhifəni yeniləyin.",
      noWeight2: "Çəki 2 boş ola bilməz. Zəhmət olmasa, səhifəni yeniləyin.",
      dividedSumGtThanNet: "Bölüşdürülən çəki net çəkidən çox ola bilməz.",
      emptyWeight:
        "Seçdiyiniz avtomobilin boş çəkisi olmadığı üçün avtomobili dəyişmək mümkün olmadı.",
      technicalPassportWeight:
        "Seçdiyiniz avtomobilin Tex pasport ağırlığı olmadığı üçün avtomobili dəyişmək mümkün olmadı.",
      technicalTrailerPassportWeight:
        "Seçdiyiniz qoşqunun Tex pasport ağırlığı olmadığı üçün qoşqunu dəyişmək mümkün olmadı.",
    },
    errorPage: {
      code: "Xəta kodu: {{code}}",
      notFoundTitle: "Axtardığınız səhifə tapılmadı",
      notFoundDescription:
        "Keçid silinmiş, dəyişdirilmiş və ya yanlış daxil edilmiş ola bilər.",
      errorTitle: "Gözlənilməz xəta baş verdi",
      errorDescription:
        "Səhifəni yenidən yükləyin. Problem davam edərsə, sistem administratoru ilə əlaqə saxlayın.",
      home: "Ana səhifə",
      back: "Geri qayıt",
      tryAgain: "Yenidən yoxla",
      help: "Problem təkrarlanarsa, xəta kodunu administratora bildirin.",
    },
    utils: {
      and: "və",
      weight: "çəki",
      full: "dolu",
      empty: "boş",
      count: "say",
      yes: "bəli",
      no: "xeyr",
      ok: "Tamam",
      type: "tip",
      add: "əlavə et",
      create: "yarat",
      edit: "dəyiş",
      update: "redaktə et",
      created: "Yaradan istifadəçi",
      name: "ad",
      eg: "məs.",
      calibration: "Kalibrasiya",
      note: "Qeyd",
      green: "Yaşıl",
      red: "Qırmızı",
      version: "Versiyası",
      description: "Açıqlama",
      logType: "Log növü",
      kg: "kq",
      id: "Şəxsiyyət vəsiqəsi nömrəsi",
      birthDate: "Doğum tarixi",
      area: "Rayon",
      district: "İnzibati ərazi",
      country: "Ölkə",
      authorizedPerson: "Səlahiyyətli şəxs",
      volume: "Həcm (kq)",
      remainingVolume: "Qalan həcm (kq)",
      completedVolume: "Gedən həcm (kq)",
      file: "Fayl",
      downloadExample: "Nümunəni yüklə",
      isApproved: "Təsdiq edilib?",
      netDifference: "Çəki fərqi",
      day: "gün",
      days: "gün",
      branch: "Filial",
      warehouse: "Anbar",
      refresh: "Yenilə",
      active: "Aktiv",
      deactive: "Deaktiv",
    },
    modal: {
      close: "Bağla",
      sure: "Əminsinizmi?",
    },
    mapPicker: {
      title: "Xəritədə üzərindən ünvanı pinləyin",
      openButton: "Xəritədə pin seç",
      missingApiKey:
        "Google Maps API key təyin edilməyib.",
      loadError: "Xəritə yüklənmədi. Zəhmət olmasa yenidən cəhd edin.",
    },
    operator: {
      signature: "Operatorun imzası",
      note: "Operatorun qeydi",
      name: "Operatorun adı",
    },
    admin: {
      note: "Adminin qeydi",
    },
    logon: {
      chooseTruck: "Avtomobil təyin et",
    },
    nav: {
      aiAnalyze: "AI yoxlama",
      dashboard: "Ana səhifə",
      incomes: "Mədaxillər",
      reports: {
        default: "Hesabatlar",
        sum: "Sum",
        summReporter: "Summ Reporter",
        groupSum: "Qrup Sum",
        dividedSum: "Bölünmüş sum",
      },
      orders: "Sifarişlər",
      subOrders: "Alt Sifarişlər",
      orderParts: "Sifariş bağlantıları",
      logonRequests: "Logon sorğuları",
      new: {
        order: "Sifariş",
        default: "Yeni",
        customer: "Müştəri və ya təchizatçı",
        customerBranches: "Müştəri və ya təchizatçı filialları",
        customerWarehouse: "Müştəri anbarı",
        senderWarehouse: "Göndərən anbarı",
        senderBranches: "Göndərən filialları",
        companyBranches: "Şirkət filialları",
        cargo: "Yük",
        cargoType: "Yük tipi",
        subCargo: "Alt yük",
        truckOwner: "Sürücü",
        truck: "Avtomobil",
        trailer: "Qoşqu",
        sender: "Göndərən",
        truckType: "Avtomobil tipləri",
        carBrands: "Avtomobil markaları",
        carModels: "Avtomobil modelləri",
        deliveryTypes: "Çatdırılma növləri",
        companyAllowedIpAddress: "Şirkət IP adresləri",
        scaleCamera: "Kameralar",
        senderWarehouseConfig: "Göndərən anbarı config",
      },
      requests: {
        default: "Sorğular",
        completed: "Tamamlanmış",
        waiting: "Cavab gözləyən",
        approved: "Təsdiq edilmiş mədaxillər",
        cancelled: "Ləğv edilmiş mədaxillər",
      },
      lpi: {
        reset: "Sıfırla",
        default: "LPİ",
        ipAddress: "LPİ İP adres",
        port: "LPİ port",
        history: "LPİ tarixçəsi",
        statusHistory: "Status tarixçəsi",
        calibrationHistory: "Kalibrasiya tarixçəsi",
        realWeight: "Real çəki",
        enteredWeight: "Daxil edilən çəki",
        calibrate: "Kalibrasiya et",
        deviceOperations: "Qurğu düymələri üzərində əməliyyatlar",
        calibrationStatus: "Kalibrasiya statusu",
        lock: "Kilidlə",
        unlock: "Kilidi aç",
        calibrationActive: "Kalibrasiya aktivdir",
        activateCalibration: "Kalibrasiyanı aktiv et",
        calibrationWarning:
          "Tərəzinin üzərini boşaldın, tərəzinin tam boş olduğundan əmin olun.",
        enterCalibrationValue: "Kalibrasiya dəyərini daxil edin",
        lpiCalibrate: "LPİ kalibrasiya et",
      },
      history: "Tarixçə",
      importData: "Məlumatları yüklə",
      companies: "Şirkətlər",
      companiesQr: "Şirkətlər QR-kod",
      scales: "Tərəzilər",
      rfidCards: "RFİD kartlar",
      rfidCardOperations: "RFİD kart bağlantıları",
      users: "İstifadəçilər",
      logout: "Çıxış",
      scaleCard: 'Tərəzi kartları',
      serviceCard: 'Servis kartları',
      localServiceLogs: 'Local servis logları'
    },
    user: {
      username: "İstifadəçi adı",
      oldPassword: "Köhnə şifrə",
      newPassword: "Yeni şifrə",
      changePassword: "Şifrəni dəyiş",
      resetPassword: "Şifrəni sıfırla",
      phone: "Telefon",
      address: "Ünvan",
      latitude: "Latitude",
      longitude: "Longitude",
      role: "İstifadəçi rolu",
      add: "YENİ İSTİFADƏÇİ ƏLAVƏ ET",
      create: "İstifadəçinin yaradılması",
      edit: "İstifadəçinin dəyişdirilməsi",
      addToast: "İstifadəçi əlavə olundu",
      resendMailConfirm: "Email yenidən göndərilsin?",
      approveUserConfirm: "İstifadəçi təsdiq edilsin?",
      invite: "İSTİFADƏÇİ DƏVƏT ET",
      fullname: "Ad soyad",
      resendApproveMail: "Təsdiq maili göndər",
      resendInviteMail: "Dəvət maili göndər",
      deleteCurrentImage: "Cari profil şəklini sil?",
      details: "İstifadəçi detalları",
      operatorPermission: "İcazə verilən gün sayı",
      guardType: "Mühafizəçi növü",
      canWriteLossPercentage: "İtki faizi yazır?",
      lossPercentageAvailable: "İtki faizi?",
      canShowNewMenu: "Yeni menyusunu görsün",
      canShowOperation: "Tartım düymələrini görsün",
      canShowOrderPart: "Sifariş bağlantılarını görsün",
      canShowReport: "Hesabatları görsün",
      canShowOrderPartCompleted: "Tamamlanmış sifariş bağlantılarını görsün",
      isDispetcher: "Dispetçer?",
      mustChangePassAtNextLogin: "Məcburi şifrə dəyişikliyi",
      canDivideOperation: "Çoxlu müştəri/göndərən",
      aynaSyncAvailable: "AYNA İnteqrasiya",
    },
    rfidCard: {
      rfidNumber: "RFİD nömrəsi",
      cardNumber: "Kart nömrəsi",
      cardType: "Kart növü",
      operation: "Bağlantı",
      operations: "Kart bağlantıları",
      history: "Kart tarixçəsi",
      add: "YENİ RFİD KART ƏLAVƏ ET",
      create: "RFİD kartının yaradılması",
      edit: "RFİD kartının dəyişdirilməsi",
      reset: "Kartı sıfırlamaq istədiyinizdən əminsinizmi?",
      delete: "Kartı silmək istədiyinizdən əminsinizmi?",
      resetButton: "Sıfırla",
      addToast: "RFİD kart əlavə olundu",
      addOperationToast: "RFİD kart bağlantısı yaradıldı",
    },
    request: {
      changeInfo: "Dəyişiklik haqqında məlumat",
      deleteInfo: "Silimə haqqında məlumat",
      fieldName: "Sahə adı",
      oldValue: "Köhnə dəyər",
      newValue: "Yeni dəyər",
      user: "İstifadəçi",
      history: "Tarixçə",
      requestEdit: "Edilən dəyişiklikləri qəbul edirsinizmi?",
      requestDelete: "Edilən silinməni qəbul edirsinizmi?",
      confirm: "Qəbul et",
      deny: "Rədd et",
    },
    history: {
      tableName: "Cədvəl adı",
    },
    regex: {
      required: "Bu xana məcburidir",
      number: "Bu xanada yalnız ədəd olmalıdır",
      positiveNumber: "Ədəd müsbət olmalıdır",
      min3: "Daxil edilən simvol sayı minimum 3 olmalıdır",
      min5: "Daxil edilən simvol sayı minimum 5 olmalıdır",
      length10: "Bu xana 10 simvoldan ibarət olmalıdır",
      password:
        "Şifrə minimum 6 simvol, ən azından bir böyük hərf, bir kiçik hərf və bir rəqəmdən ibarət olmalıdır",
      confirmPassword: "Zəhmət olmasa, təkrar şifrəni düzgün daxil edin",
      email: "Zəhmət olmasa, düzgün e-poçt ünvanı daxil edin",
      phone: "Zəhmət olmasa, düzgün telefon nömrəsi daxil edin",
      telegram: "Zəhmət olmasa, düzgün telegram nömrəsi daxil edin",
      numberPlate: "Zəhmət olmasa, düzgün avtomobil nömrəsi daxil edin",
      branchCode: "Filial kodu 1234567890-12345 formatında olmalıdır",
      emptyWeight: "Ədəd müsbət və maksimum 2 onluq yeri olmalıdır",
      customerType: "Tip seçimi məcburidir",
      coordinateNumber: "Koordinat düzgün rəqəm olmalıdır",
      latitudeRange: "Latitude -90 ilə 90 arasında olmalıdır",
      longitudeRange: "Longitude -180 ilə 180 arasında olmalıdır",
      coordinatePair: "Latitude və Longitude birlikdə daxil edilməlidir",
      numberPlateExists: "Bu avtomobil sistemdə mövcuddur",
    },
    calibrationExpired:
      "Şirkətin kalibrasiya zamanı keçmişdir. Kalibrasiya zamanı {{date}} tarixində idi.",
    calibrationNext:
      "Şirkətin kalibrasiya zamanı {{date}} tarixindədir. Şirkətin növbəti kalibrasiya zamanına {{days}} gün qaldı.",
    netDifference: "Çəki fərqi: {{NetDifference}}",
    continueWithEmptyWeight:
      "Avtomobilin boş çəkisi mövcuddur. Boş çəki ilə davam edilsin?",
    copyright: "Bütün hüquqlar qorunur",
    incomeOperation: {
      approve: "Təsdiq",
      cancel: "İmtina",
      detailed: "Ətraflı",
    },
    print3: {
      organizationName: "Müştəri",
      entranceDate: "Tarix",
      exitDate: "Tarix(net)",
      entranceTime: "Saat",
      exitTime: "Saat(net)",
      kontragent: "Göndərən",
    },
  },
};

export default az;
